import React from 'react';
import './Planos.css';
import imgPasses from '../assets/imgpasses.PNG';
import imgMembership from '../assets/imgmembership.PNG';
import Header2 from '../components/Header2';   // 👈 importa o Header2

const Planos = () => {
  return (
    <>
      {/* Header com fundo sólido (preto) para não sumir no fundo branco */}
      <Header2 solid />

      <section className="planos-section">
        <h2 className="planos-title">PLANOS RETROFLEX</h2>

        <div className="planos-container">
          <div className="plano-card">
            <img src={imgMembership} alt="Membership" className="planos-image" />
            <h3 className="planos-text">PLANOS</h3>

            <div className="planos-list">
              <div className="plano-item">
                <p className="planos-description">
                  <strong>Planos em manutenção.</strong>
                </p>
                <p className="planos-description">
                  Estamos atualizando as informações dos planos Retroflex.
                </p>
                <p className="planos-description">
                  Entre em contato para consultar disponibilidade.
                </p>
              </div>
            </div>
          </div>

          <div className="plano-card">
            <img src={imgPasses} alt="Passes" className="planos-image" />
            <h3 className="planos-text">VALORES SEM PLANO</h3>

            <ul className="planos-list">
              <li className="planos-description">
                <strong>Valores em manutenção.</strong>
              </li>
              <li className="planos-description">
                Estamos atualizando as informações de passes e diárias.
              </li>
            </ul>
          </div>
        </div>
      </section>
    </>
  );
};

export default Planos;
